document.addEventListener("DOMContentLoaded", function() {
    setTimeout(()=>{
        const links = document.querySelectorAll('a');
        links.forEach(function(link) {
            if(link.href){
                const hostname = new URL(link.href).hostname;
                if (hostname !== window.location.hostname && !link.href.includes('facebook.com') && !link.href.includes('instagram.com') && !link.href.includes('pinterest.com')) {
                    link.setAttribute('rel', 'nofollow');
                }
            }
        });
    },3000)


    //---//

    const breadcrumbs = document.querySelectorAll('.breadcrumb a');
    const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
    if(lastBreadcrumb){
        if (lastBreadcrumb.href && lastBreadcrumb.href === window.location.href) {
            lastBreadcrumb.removeAttribute('href');
            lastBreadcrumb.style.pointerEvents = 'none';
        }
    }


    //---//

    const paginationLinks = document.querySelectorAll('.pagination a, .js-filter a');
    if(paginationLinks){
        paginationLinks.forEach(function(link) {
            if (link.href && link.href === window.location.href) {
                link.removeAttribute('href');
                link.style.pointerEvents = 'none';
            }
        });
    }

    //---//



});






